<div class="modal-header">
  <h4 class="modal-title">
    Card delivery address  #{{cardId}}
  </h4>
  <button
    type="button"
    class="close"
    aria-describedby="modal-title"
    (click)="activeModal.close(false)"
  >
    <span>&times;</span>
  </button>
</div>
<div class="modal-body">
  <transform-table [transformInstructions]="cardDeliveryAddressTransformations" [entity]="deliveryAddress?.address"></transform-table>
</div>
<div class="modal-footer">
  <button
    type="button"
    autofocus
    class="btn btn-outline-secondary"
    (click)="activeModal.close(false)"
  >Close</button>
</div>

